import { render, staticRenderFns } from "./MeetingIcon.vue?vue&type=template&id=09920802"
import script from "./MeetingIcon.vue?vue&type=script&lang=js"
export * from "./MeetingIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports